<div
    *ngFor="let requirement of requirements(); trackBy: trackByFn"
    class="relative flex border-t first:border-0"
    [ngClass]="[
        selectionOn && selectedRequirement && selectedRequirement.id === requirement.id
            ? 'bg-hover'
            : '',
        selectionOn ? 'cursor-pointer hover:bg-hover' : '',
    ]"
    (click)="selectRequirement(requirement)">
    <!-- Item content -->
    <div
        class="flex w-full flex-col items-start justify-start border-l-4 border-transparent py-6 pl-5 pr-4"
        [ngClass]="{
            'border-primary': requirement.unread,
            'bg-primary-50 dark:bg-black dark:bg-opacity-5':
                selectedrequirement && selectedrequirement.id === requirement.id,
        }">
        <!-- Info -->
        <div class="flex w-full items-center">
            <!-- Sender name -->
            <div class="mr-2 truncate font-semibold">
                {{ requirement.authorName }}
            </div>
            <!-- Important indicator -->
            @if (requirement.important) {
                <mat-icon
                    class="mr-3 text-red-500 icon-size-4 dark:text-red-600"
                    [svgIcon]="'heroicons_solid:exclamation-circle'"></mat-icon>
            }
            <!-- Date -->
            <div class="text-hint ml-auto whitespace-nowrap text-right text-md">
                {{ requirement.date | date: 'LLL dd' }}
            </div>
        </div>

        <!-- Subject -->
        <div class="mt-1 flex w-full items-center">
            <span class="truncate leading-4">{{ requirement.subject }}</span>
            <!-- Indicators -->
            @if (
                (requirement.attachments && requirement.attachments.length > 0) ||
                requirement.starred
            ) {
                <div class="ml-auto flex pl-2">
                    <!-- Attachments -->
                    @if (requirement.attachments && requirement.attachments.length > 0) {
                        <mat-icon
                            class="flex justify-center icon-size-4"
                            [svgIcon]="'heroicons_solid:paper-clip'"></mat-icon>
                    }
                    <!-- Starred -->
                    @if (requirement.starred) {
                        <mat-icon
                            class="ml-1 flex justify-center text-orange-500 icon-size-4 dark:text-orange-400"
                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                    }
                </div>
            }
        </div>
    </div>
</div>
